import React, { Component } from "react";
import { updateChangePasswordNew } from "../_services/changePassword.service";
import ESSModal from "../components/ESSModal.jsx";
import Modal from "react-bootstrap/Modal";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      showLoginBox: false,
    };
  }

  searchClicked = () => {
    updateChangePasswordNew(
      this.state.oldPassword.trim(),
      this.state.newPassword.trim()
    ).then((_data) =>{
      console.log(_data)
      if(_data.returnCode == 0)
        this.setState({ showLoginBox: true, userMessage: 'Password has been changed' })
      else if(_data.returnCode == 20)
        this.setState({ showLoginBox: true, userMessage: 'Invalid Login Id' })
      else if(_data.returnCode == 40)
        this.setState({ showLoginBox: true, userMessage: 'Invalid Old Password' })
      else if(_data.returnCode == 50)
        this.setState({ showLoginBox: true, userMessage: 'New Password must be at least 6 characters' })
      else if(_data.returnCode == 60)
        this.setState({ showLoginBox: true, userMessage: "New Password must not contain space or invalid special characters" })
      else if(_data.returnCode == 70)
        this.setState({ showLoginBox: true, userMessage: 'New Password must contain both letters and numbers' })
      else
        this.setState({ showLoginBox: true, userMessage: 'Error while updating password' })
      
      this.clearClicked();
    })
    .catch((err) => {
      alert("Error while updating password please try agin later");
   });
  };

  handleClose = () => this.setState({ showLoginBox: false });

  clearClicked = () => {
    this.setState({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  inputHandler = (event) => {
    switch (event.target.name) {
      case "oldPassword":
        this.setState({ oldPassword: event.target.value });
        break;
      case "newPassword":
        this.setState({ newPassword: event.target.value });
        break;
      case "confirmPassword":
        this.setState({ confirmPassword: event.target.value });
        break;
      default:
    }
  };

  renderChangePasswordForm() {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
        }}
      >

      {this.state.showLoginBox && (
                <ESSModal
                  handle2ndButtonClick={this.handle2ndButtonClick}
                  handleClose={this.handleClose}
                  btn1Text="Ok"
                  userMessage={this.state.userMessage}
                  isAlert="true"
                  isContentMessage="true"
                  show={this.state.showLoginBox}
                />
              )}

        <div class="form-group row">
          <label className="col-sm-5 col-form-label ">Old Password: </label>
          <div className="col-sm-7">
            <input
              type="text"
              className="form-control form-control-sm filterControls"
              placeholder="Old Password"
              value={this.state.oldPassword}
              name="oldPassword"
              onChange={this.inputHandler}
            ></input>
          </div>
        </div>
        <div class="form-group row">
          <label className="col-sm-5 col-form-label ">New Password: </label>
          <div className="col-sm-7">
            <input
              type="text"
              className="form-control form-control-sm filterControls"
              placeholder="New Password"
              value={this.state.newPassword}
              name="newPassword"
              onChange={this.inputHandler}
            ></input>
          </div>
        </div>
        <div class="form-group row">
          <label className="col-sm-5 col-form-label ">Confirm Password: </label>
          <div className="col-sm-7">
            <input
              type="text"
              className="form-control form-control-sm filterControls"
              placeholder="Confirm Password"
              value={this.state.confirmPassword}
              name="confirmPassword"
              onChange={this.inputHandler}
            ></input>
          </div>
        </div>
        <div class="form-group row">
          <div className="col-sm-3">
            <button
              className="btn btn-primary btn-sm filterButtons"
              type="button"
              onClick={this.searchClicked}
              disabled={
                !this.state.oldPassword ||
                !this.state.newPassword ||
                !this.state.confirmPassword ||
                this.state.oldPassword.trim() ==
                  this.state.newPassword.trim() ||
                this.state.newPassword.trim() !==
                  this.state.confirmPassword.trim()
              }
            >
              Change
            </button>
          </div>
          <div className="col-sm-3">
            <button
              className="btn btn-primary btn-sm filterButtons"
              type="button"
              onClick={this.clearClicked}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div class="container-fluid h-100">
        <div class="row justify-content-center align-items-center h-100 ">
          <div class="col col-sm-6 col-md-6 col-lg-4 col-xl-3 loginBox">
            <div class="form-group row">
              <div
                className="col-sm-12"
                style={{ color: "white", fontSize: "20px" }}
              >
                Change Password
              </div>
            </div>
            {this.renderChangePasswordForm()}
          </div>
        </div>
      </div>
    );
  }
}
export default ChangePassword;
